import localFont from 'next/font/local'

const ttRoundsNeueVariable = localFont({
  src: '../../assets/TT_Rounds_Neue_Variable.ttf',
})

export const bodyFont = ttRoundsNeueVariable
export const displayFont = ttRoundsNeueVariable
